// src/services/productService.js
import { catalogApi } from '../utils/apiConfig';

export const productService = {
  getLowPriceVariants: async (orderType = 'QUICK') => {
    try {
      const response = await catalogApi.get('/api/v1/customer/low-price', {
        params: { orderType }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching low-price variants:", error);
      throw error;
    }
  },
  getCategories: async (deliveryType = 'QUICK') => {
    try {
      const response = await catalogApi.get('/api/v1/category/delivery', {
        params: { deliveryType }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw error;
    }
  },
  getProductsByCategory: async (categoryId, deliveryType = 'QUICK') => {
    try {
      const response = await catalogApi.get(`/api/v1/customer/category/${categoryId}/products`, {
        params: { deliveryType }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching products by category:", error);
      throw error;
    }
  },
  searchProducts: async (keyword) => {
    try {
      const response = await catalogApi.get('/api/v1/customer/search', {
        params: { keyword }
      });
      return response.data;
    } catch (error) {
      console.error("Error searching products:", error);
      throw error;
    }
  },
  getBanners: async (bannerType, deliveryType = 'QUICK') => {
    try {
      const response = await catalogApi.get(`/api/v1/banners/type/${bannerType}`, {
        params: { deliveryType, activeOnly: true }
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${bannerType} banners:`, error);
      return []; 
    }
  },
  getAllVariantsByCategory: async (categoryId, deliveryType = 'QUICK', page = 0, size = 20) => {
    try {
      const response = await catalogApi.get(`/api/v1/customer/category/${categoryId}/all-variants`, {
        params: { deliveryType, page, size }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching all variants by category:", error);
      throw error;
    }
  },
  getVariantsByProductId: async (productId, deliveryType = 'QUICK') => {
    try {
      const response = await catalogApi.get(`/api/v1/customer/${productId}/variants`, {
        params: { deliveryType }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching variants by product:", error);
      throw error;
    }
  },
  
  // NEW: Get Offers API
  getOffers: async (deliveryType = 'QUICK') => {
    try {
      const response = await catalogApi.get('/api/v1/customer/offers', {
        params: { deliveryType }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching offers:", error);
      throw error;
    }
  }
};